module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "surveillance"
  }, [_c('el-popover', {
    ref: "filterpopover",
    attrs: {
      "placement": "bottom-end",
      "width": "300",
      "trigger": "click"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Precautions:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.precaution),
      expression: "allFilters.precaution"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.precaution)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.precaution = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Organisms:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.organism),
      expression: "allFilters.organism"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.organism)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.organism = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Resolutions:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.resolution),
      expression: "allFilters.resolution"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.resolution)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.resolution = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Family Notified:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.familyNotified),
      expression: "allFilters.familyNotified"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.familyNotified)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.familyNotified = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Next Of Kin Notified:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.nextOfKinNotified),
      expression: "allFilters.nextOfKinNotified"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.nextOfKinNotified)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.nextOfKinNotified = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Physician Notified:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.physicianNotified),
      expression: "allFilters.physicianNotified"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.physicianNotified)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.physicianNotified = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Staff:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.staffOrRes),
      expression: "allFilters.staffOrRes"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.staffOrRes)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.staffOrRes = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("First Name:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.firstName),
      expression: "allFilters.firstName"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.firstName)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.firstName = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Last Name:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilters.lastName),
      expression: "allFilters.lastName"
    }],
    attrs: {
      "on-text": "YES",
      "off-text": "NO",
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.allFilters.lastName)
    },
    on: {
      "input": function($event) {
        _vm.allFilters.lastName = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_c('span', [_vm._v("Surveillance")]), _vm._v(" "), _c('div', {
    staticClass: "case-filter"
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:filterpopover",
      arg: "filterpopover"
    }],
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("Add Filters")])], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "filter-section"
  }, [_c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Date Range:")]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateRange),
      expression: "filterDateRange"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "label": "Date Range",
      "type": "daterange",
      "placeholder": "Date Range",
      "format": "dd-MM-yyyy",
      "range-separator": " ~ ",
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "small": ""
    },
    domProps: {
      "value": (_vm.filterDateRange)
    },
    on: {
      "change": _vm.dateRangeUpdated,
      "input": function($event) {
        _vm.filterDateRange = $event
      }
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Unit:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUnit),
      expression: "selectedUnit"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Unit"
    },
    domProps: {
      "value": (_vm.selectedUnit)
    },
    on: {
      "change": _vm.unitUpdated,
      "input": function($event) {
        _vm.selectedUnit = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All Units",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.units), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.displayText,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.displayText))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.value))])])
  })], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Infection Site:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filteredSite),
      expression: "filteredSite"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Select Infection Site"
    },
    domProps: {
      "value": (_vm.filteredSite)
    },
    on: {
      "change": _vm.symptomTypeUpdated,
      "input": function($event) {
        _vm.filteredSite = $event
      }
    }
  }, _vm._l((_vm.symptomTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.allFilters.origin) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Origin:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrigin),
      expression: "selectedOrigin"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Origin"
    },
    domProps: {
      "value": (_vm.selectedOrigin)
    },
    on: {
      "change": _vm.originUpdated,
      "input": function($event) {
        _vm.selectedOrigin = $event
      }
    }
  }, _vm._l((_vm.origins), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Status"
    },
    domProps: {
      "value": (_vm.selectedStatus)
    },
    on: {
      "change": _vm.confirmStatusUpdated,
      "input": function($event) {
        _vm.selectedStatus = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Suspected",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), (_vm.allFilters.precaution) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Precautions:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPrecautions),
      expression: "selectedPrecautions"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Precautions"
    },
    domProps: {
      "value": (_vm.selectedPrecautions)
    },
    on: {
      "change": _vm.precautionUpdated,
      "input": function($event) {
        _vm.selectedPrecautions = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All Precautions",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.precautions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.displayText,
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.organism) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Organisms:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrganisms),
      expression: "selectedOrganisms"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Not Selected"
    },
    domProps: {
      "value": (_vm.selectedOrganisms)
    },
    on: {
      "change": _vm.organismsUpdated,
      "input": function($event) {
        _vm.selectedOrganisms = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Not Selected",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.organisms), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.value))])])
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.resolution) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Resolution:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedResolved),
      expression: "selectedResolved"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Resolution"
    },
    domProps: {
      "value": (_vm.selectedResolved)
    },
    on: {
      "change": _vm.resolvedUpdated,
      "input": function($event) {
        _vm.selectedResolved = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Resolved",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Not Resolved",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.familyNotified) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Family Notified:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFamilyNotified),
      expression: "selectedFamilyNotified"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Family Notified"
    },
    domProps: {
      "value": (_vm.selectedFamilyNotified)
    },
    on: {
      "change": _vm.resolvedUpdated,
      "input": function($event) {
        _vm.selectedFamilyNotified = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Notified",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Not Notified",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.nextOfKinNotified) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Next of Kin Notified:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedNextOfNotified),
      expression: "selectedNextOfNotified"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Next of Kin Notified"
    },
    domProps: {
      "value": (_vm.selectedNextOfNotified)
    },
    on: {
      "change": _vm.resolvedUpdated,
      "input": function($event) {
        _vm.selectedNextOfNotified = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Notified",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Not Notified",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.physicianNotified) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Physician Notified:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhysicianNotified),
      expression: "selectedPhysicianNotified"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Physician Notified"
    },
    domProps: {
      "value": (_vm.selectedPhysicianNotified)
    },
    on: {
      "change": _vm.resolvedUpdated,
      "input": function($event) {
        _vm.selectedPhysicianNotified = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Notified",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Not Notified",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.staffOrRes) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Client Type:")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedClientType),
      expression: "selectedClientType"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Client Type"
    },
    domProps: {
      "value": (_vm.selectedClientType)
    },
    on: {
      "change": _vm.resolvedUpdated,
      "input": function($event) {
        _vm.selectedClientType = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Resident",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Staff",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.firstName) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("First Name:")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFirstName),
      expression: "selectedFirstName"
    }],
    attrs: {
      "placeholder": "First Name",
      "icon": "search",
      "on-icon-click": _vm.resolvedUpdated
    },
    domProps: {
      "value": (_vm.selectedFirstName)
    },
    on: {
      "input": function($event) {
        _vm.selectedFirstName = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.lastName) ? _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Last Name:")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLastName),
      expression: "selectedLastName"
    }],
    attrs: {
      "placeholder": "Last Name",
      "icon": "search",
      "on-icon-click": _vm.resolvedUpdated
    },
    domProps: {
      "value": (_vm.selectedLastName)
    },
    on: {
      "input": function($event) {
        _vm.selectedLastName = $event
      }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCaseDialogFormVisible),
      expression: "newCaseDialogFormVisible"
    }],
    attrs: {
      "title": "New Case"
    },
    domProps: {
      "value": (_vm.newCaseDialogFormVisible)
    },
    on: {
      "input": function($event) {
        _vm.newCaseDialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "new-case-dialog"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("Residents:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCase.client),
      expression: "newCase.client"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Not Selected"
    },
    domProps: {
      "value": (_vm.newCase.client)
    },
    on: {
      "input": function($event) {
        _vm.newCase.client = $event
      }
    }
  }, _vm._l((_vm.clientList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": _vm.getClientName(item),
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(_vm.getClientName(item)))])])
  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("Symptoms:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCase.symptoms),
      expression: "newCase.symptoms"
    }],
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Not Selected"
    },
    domProps: {
      "value": (_vm.newCase.symptoms)
    },
    on: {
      "input": function($event) {
        _vm.newCase.symptoms = $event
      }
    }
  }, _vm._l((_vm.symptoms), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.displayText,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.displayText))])])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addSymptoms(_vm.newCase.client, _vm.newCase.symptoms)
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.newCaseDialogFormVisible = false;
        this.newCase = {
          client: null,
          symptoms: []
        }
      }
    }
  }, [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), (_vm.selectedCase) ? _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogFormVisible),
      expression: "dialogFormVisible"
    }],
    attrs: {
      "title": _vm.clientName(_vm.selectedCase),
      "size": "large"
    },
    domProps: {
      "value": (_vm.dialogFormVisible)
    },
    on: {
      "input": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-tabs', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caseActiveTab),
      expression: "caseActiveTab"
    }],
    attrs: {
      "type": "card"
    },
    domProps: {
      "value": (_vm.caseActiveTab)
    },
    on: {
      "input": function($event) {
        _vm.caseActiveTab = $event
      }
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Case Detail",
      "name": "1"
    }
  }, [_c('surveillance-case-detail', {
    attrs: {
      "caseData": _vm.selectedCase,
      "clientData": _vm.clients[_vm.selectedCase.clientId],
      "origins": _vm.origins,
      "organisms": _vm.organisms,
      "treatments": _vm.treatments
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveSymtomDetail(_vm.selectedCase)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false;
        this.selectedCase = null
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Communication",
      "name": "2"
    }
  }, [_c('surveillance-communication', {
    attrs: {
      "caseData": _vm.selectedCase,
      "clientData": _vm.clients[_vm.selectedCase.clientId],
      "notes": _vm.selectedCase.notes
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Signs and Symptoms",
      "name": "5"
    }
  }, [_c('surveillance-symptoms', {
    attrs: {
      "caseData": _vm.selectedCase
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveSymtomDetail(_vm.selectedCase)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false;
        this.selectedCase = null
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Treatment",
      "name": "6"
    }
  }, [_c('surveillance-treatment', {
    attrs: {
      "caseData": _vm.selectedCase
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Individual",
      "name": "7"
    }
  }, [_c('surveillance-personal-info', {
    attrs: {
      "clientData": _vm.clients[_vm.selectedCase.clientId]
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Precaution",
      "name": "8"
    }
  }, [_c('surveillance-precaution', {
    attrs: {
      "caseData": _vm.selectedCase,
      "precautions": _vm.precautions,
      "clientData": _vm.clients[_vm.selectedCase.clientId]
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_c('span', [_vm._v("Case Detail - Total: " + _vm._s(_vm.symptomDetailTotal))]), _vm._v(" "), _c('div', {
    staticClass: "case-filter"
  }, [_c('el-button', {
    staticClass: "case-export-button",
    attrs: {
      "plain": true,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.createNewCase()
      }
    }
  }, [_vm._v(" + New Case")]), _vm._v(" "), _c('el-button', {
    staticClass: "case-export-button",
    attrs: {
      "plain": true,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.exportExcel()
      }
    }
  }, [_vm._v("Export Data")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "current-page": _vm.symptomDetailPage,
      "page-count": _vm.symptomDetailPageTotal
    },
    on: {
      "current-change": _vm.reloadPage
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cases,
      "default-sort": {
        prop: 'onSetDate',
        order: 'descending'
      }
    },
    on: {
      "row-click": _vm.selectedRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": " ",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticStyle: {
            "padding": "0.5em"
          }
        }, [(_vm.clients[scope.row.clientId]) ? _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.photosUrl(scope.row.clientId)
          }
        })]) : _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": require("assets/user.png")
          }
        })])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "sortable": "",
      "fixed": "",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.clients[scope.row.clientId]) ? _c('span', [_vm._v(_vm._s(_vm.clientName(scope.row))), _c('br'), _vm._v("(" + _vm._s(_vm.clients[scope.row.clientId].patientId) + ")")]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Gender",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.gender) ? _c('span', [_vm._v(_vm._s(scope.row.gender))]) : _c('span', [_vm._v("Not Entered")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DOB",
      "prop": "dateOfBirth",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.dateOfBirth) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.dateOfBirth, 'DD-MM-YYYY')))]) : _c('span', [_vm._v("Not Entered")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Infection Site",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.symptomType === 'GI') ? _c('span', {
          staticClass: "color-code-label-0"
        }) : (scope.row.symptomType === 'UTI') ? _c('span', {
          staticClass: "color-code-label-2"
        }) : _c('span', {
          staticClass: "color-code-label-1"
        }), _vm._v("\n          " + _vm._s(scope.row.symptomType) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('img', {
          staticClass: "symptom-status-image",
          attrs: {
            "src": _vm.statusImage(scope.row)
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Symptoms",
      "min-width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return _vm._l((scope.row.symptoms), function(d) {
          return _c('el-tag', {
            key: d.id,
            attrs: {
              "type": _vm.tagType(d)
            }
          }, [_vm._v(_vm._s(d.displayText))])
        })
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Precautions",
      "min-width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.clients[scope.row.clientId]) ? _c('div', _vm._l((_vm.clients[scope.row.clientId].precautionDetails), function(d) {
          return _c('el-tag', [_vm._v(_vm._s(_vm.precautionById(d.precautionId)))])
        })) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Staff",
      "min-width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.isStaff(_vm.clients[scope.row.clientId])) ? _c('span', [_vm._v("\n            Yes\n          ")]) : _c('span', [_vm._v("\n            No\n          ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Location",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.bedId]) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Origin",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.originById(scope.row.origin)) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Organism",
      "width": "220"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.organismById(scope.row.organismId)) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Treatment",
      "width": "220"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.treatmentById(scope.row.treatmentId)) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Resolution",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.resolved) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Family Notified",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.familyNotified) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Next of Kin Notified",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.nextOfNotified) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Physician Notified",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.physicianNotified) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Updated",
      "prop": "updated",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.updated, 'DD-MM-YYYY')) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Created",
      "prop": "created",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.created, 'DD-MM-YYYY')) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "Onset Date",
      "prop": "onSetDate",
      "sortable": "",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n        ")]
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1814cce6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Surveillance.vue
// module id = 239
// module chunks = 2